import { useEffect, useRef } from 'react';

import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';

import { DentrixVHLogo } from './DentrixVHLogo';

const TrialContainer = styled.div`
  font-family: 'Merriweather', serif;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60em;

  h1 {
    font-size: 2.5em;
    font-weight: 900;
    color: #0e1d3b;
    font-family: 'Merriweather', serif;
    font-weight: 700;
    margin: 0;
  }
  h2 {
    font-size: 2em;
    font-weight: 700;
    color: #0e1d3b;
    font-family: 'Merriweather', serif;
    font-weight: 700;
  }
  .cta-button {
    font-size: 1.5em;
    font-weight: 700;
    font-family: 'Proxima Nova', sans-serif;
    font-weight: 700;
    background-color: #ed7b68;
    color: white;
    border: none;
    padding: 0.75em 1.5em;
  }
  .action-button {
    font-size: 1.125em;
    font-weight: 700;
    border: none;
    color: #fff;
    font-family: 'Proxima Nova', sans-serif;
    font-weight: 700;
    background-color: #0e1d3b;
    color: white;
    padding: 0.5em 0.75em;
    text-decoration: none;
  }
`;

const TrialVideo = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 32em;
  width: 60em;
  background-color: #000;
  border-color: #fff;
  border-style: solid;
  border-width: 0 3px;
`;

const TrialContent = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 32em;
  background-color: #babcc4;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 60em;
`;
const TrialHeader = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  padding: 1.5em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
`;

const TrialSection = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 2em 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #0e1d3b;

  h4 {
    font-size: 2.5em;
    font-weight: 700;
    font-family: 'Merriweather', serif;
    font-weight: 500;
    line-height: 1.1;
    margin: 1em 0 0.5em 0;
    text-align: left;
    width: 15ch;
  }

  h2 {
    font-size: 2em;
    font-weight: 700;
    font-family: 'Merriweather', serif;
    font-weight: 700;
    line-height: 1.1;
    margin: 0.5em 0 0 0;
    text-align: center;
  }

  .trial-section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: start;
    flex-wrap: nowrap;
    gap: 2em;
    width: 100%;
    padding: 2em 0;
    position: relative;
    .trial-section-image {
      width: 26em;
      height: 28em;

      img {
        width: 90%;
        height: auto;
      }
    }

    &.light-background {
      background-color: #fff;
      color: #0e1d3b;

      h2 {
        color: #0e1d3b;
      }
      p {
        color: #0e1d3b;
      }
    }
    &.dark-background {
      background-color: #0e1d3b;
      color: #fff;

      h2 {
        color: #fff;
      }
    }
  }
  .trial-section-content {
    position: relative;
    z-index: 2;
    overflow: hidden;

    p {
      font-size: 1.125em;
      font-weight: 400;
      font-family: 'proxima-nova', sans-serif;
      font-weight: 400;
      line-height: 1.5;
      margin: 0 0 1em 0;
      width: 40ch;
    }
  }
  .trial-section-content-list-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    gap: 3em;
    padding: 3em;

    .trial-section-content-list {
      width: 45%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: stretch;
      gap: 1em;
      margin: 0;
      background-color: #0e1d3b;
      color: #fff;
      padding: 2em;
      font-family: 'proxima-nova', sans-serif;
      font-weight: 400;
      line-height: 1.5;

      h3 {
        font-size: 1.5em;
        font-family: 'Merriweather', serif;
        font-weight: 700;
        line-height: 1.5;
        margin: 0;
      }

      ul {
        margin: 0;
        padding: 1em;
      }

      li {
        font-size: 1.125em;
      }
    }
  }

  .color-pills {
    position: absolute;
    right: -1em;
    top: -1em;
    width: 302px;
    height: 638px;
    z-index: 1;
    transform: scale(0.75);

    .pill-2 {
      position: absolute;
      width: 89px;
      height: 111px;
      left: 105px;
      top: 0px;

      background: #f8d948;
      border-radius: 66px;
    }

    .pill-3 {
      position: absolute;
      width: 89px;
      height: 111px;
      left: 0px;
      top: 527px;

      background: #f6ca40;
      border-radius: 66px;
    }

    .pill-4 {
      position: absolute;
      width: 91px;
      height: 214px;
      left: 211px;
      top: 237px;

      background: #fae48c;
      border-radius: 66px;
    }

    .pill-5 {
      position: absolute;
      width: 91px;
      height: 94px;
      left: 211px;
      top: 124px;

      background: #c4a131;
      border-radius: 66px;
    }
  }
  .head-orn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1em;
  }
  .action-orn {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 1em;
    padding-bottom: 0.5em;

    h6 {
      font-size: 1.125em;
      font-weight: 700;
      font-family: 'Merriweather', sans-serif;
      font-weight: 700;
      line-height: 1.5;
      margin: 0;
    }
  }
  .action-button-container {
    padding-top: 1em;
  }

  .left-color-blocks {
    position: absolute;
    left: 3em;
    top: 1em;
    z-index: 1;
    width: 100px;
    height: 100px;
    pointer-events: none;

    &::before {
      content: '';
      position: absolute;
      width: 49px;
      height: 59px;
      left: 70px;
      top: -24px;
      z-index: 1;
      background: #71cae7;
      border-radius: 8px;
    }
    &::after {
      content: '';
      position: absolute;
      width: 49px;
      height: 47px;
      right: 40px;
      top: 31px;
      z-index: 1;
      background: #437ab8;
      border-radius: 8px;
    }
  }
  .right-color-blocks {
    position: absolute;
    right: 5em;
    top: 1em;
    z-index: 1;
    width: 100px;
    height: 100px;

    &::before {
      content: '';
      position: absolute;
      width: 49px;
      height: 59px;
      left: 90px;
      top: 59px;
      z-index: 1;
      background: #71cae7;
      border-radius: 8px;
    }

    &::after {
      content: '';
      position: absolute;
      width: 49px;
      height: 46px;
      left: 21px;
      top: 18px;
      z-index: 1;
      background: #437ab8;
      border-radius: 8px;
    }
  }
`;

export const Trial = () => {
  const practiceId = useSelector(
    (state: any) => state?.login?.user?.primaryPracticeId,
  );
  const history = useHistory();
  const bottomOfPageRef = useRef<HTMLDivElement>(null);
  const { trackEvent } = useTrackEvent();

  useEffect(() => {
    if (practiceId) {
      const urlParams = new URLSearchParams({
        detect_ai_practice_id: practiceId,
      });
      history.replace({ search: urlParams.toString() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceId]);

  useEffect(() => {
    trackEvent(mixpanelEvents.autoTrialLandOnPage);
  }, [trackEvent]);

  return (
    <TrialContainer>
      <TrialContent>
        <TrialVideo>
          <video
            controls
            width="100%"
            height="100%"
            onPlay={() => trackEvent(mixpanelEvents.autoTrialVideo)}
          >
            <source
              src="https://7124858.fs1.hubspotusercontent-na1.net/hubfs/7124858/AutoTrialTeaserVideo.mp4"
              type="video/mp4"
            />
          </video>
        </TrialVideo>
      </TrialContent>
      <TrialHeader>
        <h1>
          <Trans>Welcome to Detect AI powered by VideaHealth</Trans>
        </h1>
        <h2>
          <Trans>Available for the next 30 days</Trans>
        </h2>
        <button
          className="cta-button"
          onClick={() => {
            bottomOfPageRef.current?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <Trans>Get Started in 15 minutes</Trans>
        </button>
      </TrialHeader>
      <TrialSection>
        <DentrixVHLogo />
        <div className="trial-section dark-background">
          <div className="trial-section-content">
            <h4>
              <Trans>Elevate patient care with dental AI</Trans>
            </h4>
            <p>
              <Trans>
                Dentrix Detect Al, powered and manufactured by VideaHealth, uses
                artificial intelligence (Al) to automatically enhance x-ray
                scans with Al-enabled caries detections, Interproximal
                Radiographic Bone Level (RBL) mesurements, calculus, and
                periapical radiolucencies (PRL).
              </Trans>
            </p>
            <p>
              <Trans>
                Using the VideaHealth technology, which is fully integrated into
                the Dentrix imaging workflow, dentists can confirm patient
                conditions faster and help patients better understand proposed
                treatments so they can achieve better patient care.
              </Trans>
            </p>
          </div>
          <div className="trial-section-image">
            <img
              src="/assets/images/graphics.png"
              className="trial-section-image-element"
              alt="AI-powered dental x-ray"
            />
          </div>
          <div className="left-color-blocks"></div>
          <div className="right-color-blocks"></div>
        </div>
        <div className="trial-section light-background">
          <div className="color-pills">
            <div className="pill-2"></div>
            <div className="pill-3"></div>
            <div className="pill-4"></div>
            <div className="pill-5"></div>
          </div>
          <div className="trial-section-content">
            <h2>
              <Trans>
                Unlock new features and results over the next 30 days
              </Trans>
            </h2>
            <div className="trial-section-content-list-container">
              <div className="trial-section-content-list">
                <h3>
                  <Trans>Al-powered Capabilities</Trans>
                </h3>
                <ul>
                  <li>
                    <Trans>
                      Caries detection for patients aged three and older
                    </Trans>
                  </li>
                  <li>
                    <Trans>
                      Calculus detections with radiographic bone level
                    </Trans>
                  </li>
                  <li>
                    <Trans>
                      Patient-friendly annotations to support education and case
                      acceptance
                    </Trans>
                  </li>
                </ul>
              </div>
              <div className="trial-section-content-list">
                <h3>
                  <Trans>Al-powered Results</Trans>
                </h3>
                <ul>
                  <li>
                    <Trans>
                      85% improvement in true calculus identification*
                    </Trans>
                  </li>
                  <li>
                    <Trans>
                      119% improvement in true caries identification*
                    </Trans>
                  </li>
                  <li>
                    <Trans>
                      42% improvement in true periapical radiolucencies
                      identification*
                    </Trans>
                  </li>
                </ul>
                <div className="note">
                  <Trans>
                    * while achieving an overall clinically beneficial detection
                    rate.
                  </Trans>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="trial-section light-background">
          <div className="head-orn">
            <img src="/assets/images/graphics-blocks1.png" alt="ornanment" />
            <h2>
              <Trans>We&apos;re here to help!</Trans>
            </h2>
            <img src="/assets/images/graphics-block2.png" alt="ornanment" />
          </div>
        </div>
        <div className="trial-section light-background">
          <div className="trial-section-image-landscape">
            <img
              src="/assets/images/graphics-stock1.png"
              alt="AI-powered dental x-ray"
            />
          </div>
          <div className="trial-section-content">
            <p>
              <Trans>
                <div className="action-orn">
                  <h6>Online Learning</h6>
                  <img src="/assets/images/graphics-orn1.png" alt="ornanment" />
                </div>
                Get up to quickly by watching a quick 15 minute video.
                <div className="action-button-container">
                  <a
                    href="https://videahealth.ewebinar.com/webinar/dentrix-detect-ai-powered-by-videahealth-17232/join"
                    className="action-button"
                    onClick={() => trackEvent(mixpanelEvents.autoTrialWebinar)}
                  >
                    Go to Webinar
                  </a>
                </div>
              </Trans>
            </p>
          </div>
        </div>
        <div className="trial-section light-background">
          <div className="trial-section-image-landscape">
            <img
              src="/assets/images/graphics-stock2.png"
              alt="AI-powered dental x-ray"
            />
          </div>
          <div className="trial-section-content" ref={bottomOfPageRef}>
            <p>
              <Trans>
                <div className="action-orn">
                  <h6>Live Onboarding</h6>
                  <img src="/assets/images/graphics-orn2.png" alt="ornanment" />
                </div>
                Sign up for a 15 minute onboarding session with a Detect AI
                specialist.
                <div className="action-button-container">
                  <a
                    href="https://meetings.hubspot.com/austin405?uuid=c0fa5baa-2090-4824-bca1-e41eda3c8985"
                    className="action-button"
                    onClick={() => trackEvent(mixpanelEvents.autoTrialSchedule)}
                  >
                    Schedule Now
                  </a>
                </div>
              </Trans>
            </p>
          </div>
        </div>
      </TrialSection>
    </TrialContainer>
  );
};
